// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CustomerReview extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  acknowledged!: boolean;
  acknowledgedBy?: string;
  additionalComments?: string;
  address?: string;
  adminProcess?: string;
  businessName?: string;
  created!: Date;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  firstName?: string;
  functionality?: string;
  isBoatOwner!: boolean;
  isDealer!: boolean;
  lastName?: string;
  orderingProcess?: string;
  other?: string;
  overallSatisfaction?: string;
  phone?: string;
  processed?: Date;
  productOrService?: string;
  productPerformance?: string;
  quality?: string;
  rawData?: string;
  title?: string;
}

